import { filmsApi } from "../api/filmsApi";

/**
 * One move of a talent's base hourly rate, as the server logged it: from
 * what, to what, when, and by whom. Rates carry 4 decimals like the talent's
 * own baseHourlyRate.
 */
export type TalentRateChange = {
  id: number;
  talentID: number;
  fromRate: number;
  toRate: number;
  author: string;
  authorUUID: string;
  createdAt: string;
  updatedAt: string;
};

export const talentRateChangeEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getTalentRateChanges: build.query<TalentRateChange[], number>({
      query: (talentID) => ({
        url: `talentRateChanges`,
        params: {
          filters: JSON.stringify([
            {
              name: "talent_rate_changes.talentID",
              value: talentID,
              comparison: "eq",
            },
          ]),
        },
      }),
      // The log grows when a talent's rate is saved, and every talent
      // mutation invalidates "talents" — so the history rides along.
      providesTags: ["talents"],
    }),
    deleteTalentRateChange: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `talentRateChanges/${id}`,
      }),
      invalidatesTags: ["talents"],
    }),
  }),
});

export const {
  useGetTalentRateChangesQuery,
  useDeleteTalentRateChangeMutation,
} = talentRateChangeEndpoints;
